import service from "@/libs/service";

export const namespaced = true;

export const state = {
    policy: {}
};

export const mutations = {
    SET_POLICY(state, policy) {
        state.policy = policy;
    }
};

export const actions = {
    getPermissions({ commit }, resource) {
        return new Promise((resolve, reject) => {
            service.request("/assets/permissions", resource).then(content => {
                resolve(content);
            }).catch(err => {
                reject(err);
            });
        });
    },
    upload({ commit }, data) {
        return new Promise((resolve, reject) => {
            service.custom(data.url, data.form).then(content => {
                resolve();
            }).catch(err => {
                reject(err);
            });
        });
    },
    uploadInvoice({ commit }, data) {
        return new Promise((resolve, reject) => {
            service.request("/accounts/upload/invoice", data).then(content => {
                resolve(content);
            }).catch(err => {
                reject(err);
            });
        });
    }
};

export const getters = {
};

export default {
    state,
    mutations,
    actions,
    getters
};
